import * as React from 'react';
import { Button as BaseButton } from 'antd';
import { FileAddOutlined } from '@ant-design/icons';



const AddButton = ({ disabled, onClick, loading }) => {
    return (
        <BaseButton
            type="primary"
            danger={!disabled}
            loading={loading}
            size="large"
            disabled={disabled}
            shape="circle"
            onClick={onClick}
            icon={<FileAddOutlined />}
        />
    );
};
export default AddButton;